import clsx from 'clsx'
import RiasecInsights from '../../../../components/discover/aivy-pdf-reports/components/matchingProfile/RiasecInsights'

export default function RiasecDimensionMatchMessage({
  riasec,
  language,
  className
}) {
  return (
    <div className={clsx('w-full bg-white', className)}>
      <RiasecInsights
        {...{ ...riasec.riasec_insights, language }}
        containerStyle={{ marginTop: 16 }}
        renderedInDetailsMessage={true}
      />
    </div>
  )
}
